import React from 'react'
import PatientTable from './patient-table/PatientTable'

const PracticePatientSettings = (props) => {

    return (
        <div>
            <div title="PracticePatient">
                {/* <AccordionTemplate id="patients" accordionId="patients"> */}
                    {/* <div title="Patients"> */}
                        <PatientTable />
                    {/* </div> */}
                    {/* <div title="Patient Uploads">
                        <PatientUploadTable />
                    </div> */}
                {/* </AccordionTemplate> */}
            </div>
        </div>
    )
}

export default PracticePatientSettings